module.exports = __webpack_public_path__ + "img/ice-climber.73ece351.png";